import React, { useEffect, useState } from 'react';
import { useActionData, useLoaderData, useSubmit } from 'react-router-dom';
import { PDFViewer } from '@react-pdf/renderer';
import ReportsSearcher from '../../ReportsSearcher/ReportsSearcher';
import {
  formatShortDate,
  getCurrentFormattedDate,
  getCurrentTimeZone,
} from '../utils/helpers';
import SalesPDF from '../../../PDF/ReportsPDFGenerator/SalesPDF/SalesPDF';
import { getCompanyInfo } from '../../../../routes/reports/reportsLA';

function CustomersCSVFiles() {
  const { customers } = useLoaderData();
  const [fetchedData, setFetchedData] = useState(false);
  const [data, setData] = useState({});
  const [selectOption, setSelectOption] = useState('none');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [enablePrintDownload, setEnablePrintDownload] = useState(false);
  const [userCompany, setUserCompany] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (toDate && fromDate !== '') {
      setEnablePrintDownload(true);
    }
    setFetchedData(false);
  }, [fromDate, toDate]);

  useEffect(() => {
    if (selectOption !== 'none') {
      setFetchedData(false);
    }
  }, [selectOption, fromDate, toDate]);

  const customersArray = customers.map((item) => ({
    id: item.id,
    title: item.name,
  }));

  const submit = useSubmit();
  const actionData = useActionData();

  useEffect(() => {
    if (actionData !== undefined) {
      setData(actionData);
      setFetchedData(true);
    }
  }, [actionData]);

  const handleRunReport = async () => {
    setLoading(true);
    const values = new FormData();
    values.append('customer', selectOption);
    values.append('from', fromDate);
    values.append('to', toDate);
    submit(values, { method: 'post' });
    setLoading(false);
  };

  const getUserCompany = async () => {
    const { user } = await getCompanyInfo();
    setUserCompany(user.user_company);
  };

  useEffect(() => {
    getUserCompany();
  }, []);

  const pdfFile = (
    <SalesPDF
      fetchedData={data}
      salesCustomer
      title="Sales by Customer Report"
      from={formatShortDate(fromDate)}
      to={formatShortDate(toDate)}
      currentDate={getCurrentFormattedDate()}
      timezone={getCurrentTimeZone()}
      userCompany={userCompany}
    />
  );

  return (
    <div>
      <ReportsSearcher
        pdfFileName="sales-by-customer-report"
        options={customersArray}
        setSelectOption={setSelectOption}
        selectOption={selectOption}
        setFromDate={setFromDate}
        fromDate={fromDate}
        toDate={toDate}
        setToDate={setToDate}
        pdfChildren={pdfFile}
        enablePrintDownload={enablePrintDownload}
        handleRunReport={enablePrintDownload ? handleRunReport : () => {}}
        loading={loading}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 40,
        }}
      >
        {fetchedData && (
          <PDFViewer height={705} width={500} showToolbar={false}>
            {pdfFile}
          </PDFViewer>
        )}
      </div>
    </div>
  );
}

export default CustomersCSVFiles;
